export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const UPDATE_USER_GROUPS = 'UPDATE_USER_GROUPS';
export const UPDATE_ACCOUNT_USER = 'UPDATE_ACCOUNT_USER';
export const UPDATE_ORG_REGION = 'UPDATE_ORG_REGION';
